import { useState, useEffect } from "react";
import axios from "axios";
import {
  Users, BarChart3, CreditCard, Activity, TrendingUp, Sparkles, FileText, Briefcase
} from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminOverview() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetch = async () => {
      try {
        const res = await axios.get(`${API}/admin/overview`);
        setData(res.data);
      } catch { /* handled by auth */ }
      finally { setLoading(false); }
    };
    fetch();
  }, []);

  if (loading || !data) {
    return <div style={{ textAlign: "center", padding: "4rem" }}><div className="processing-spinner" /></div>;
  }

  const { users, activity, revenue } = data;

  return (
    <div className="page-container fade-in" data-testid="admin-overview">
      <div className="page-header">
        <div>
          <h1>Platform Overview</h1>
          <p className="page-subtitle">Real-time health of your SaaS platform.</p>
        </div>
      </div>

      {/* Revenue Hero */}
      <div className="admin-revenue-hero" data-testid="admin-revenue-hero">
        <div className="admin-rev-block">
          <span className="admin-rev-label">Total Revenue</span>
          <span className="admin-rev-amount" data-testid="total-revenue">{revenue.total_display}</span>
          <span className="admin-rev-sub">{revenue.total_payments} payments</span>
        </div>
        <div className="admin-rev-divider" />
        <div className="admin-rev-block">
          <span className="admin-rev-label">Monthly Recurring</span>
          <span className="admin-rev-amount admin-rev-mrr" data-testid="mrr">{revenue.mrr_display}</span>
          <span className="admin-rev-sub">last 30 days</span>
        </div>
      </div>

      {/* User Stats */}
      <h2 className="admin-section-title"><Users size={16} /> Users</h2>
      <div className="admin-stats-grid" data-testid="admin-user-stats">
        <StatCard icon={Users} label="Total Users" value={users.total} />
        <StatCard icon={TrendingUp} label="New This Week" value={users.new_this_week} accent />
        <StatCard icon={Activity} label="Trial" value={users.trial} />
        <StatCard icon={CreditCard} label="Base" value={users.base} />
        <StatCard icon={Sparkles} label="Unlimited" value={users.unlimited} />
      </div>

      {/* Activity Stats */}
      <h2 className="admin-section-title"><BarChart3 size={16} /> Activity</h2>
      <div className="admin-stats-grid" data-testid="admin-activity-stats">
        <StatCard icon={Sparkles} label="Total Optimizations" value={activity.total_optimizations} />
        <StatCard icon={TrendingUp} label="This Week" value={activity.optimizations_this_week} accent />
        <StatCard icon={FileText} label="Cover Letters" value={activity.total_cover_letters} />
        <StatCard icon={Briefcase} label="Job Applications" value={activity.total_applications} />
      </div>
    </div>
  );
}

function StatCard({ icon: Icon, label, value, accent }) {
  return (
    <div className={`admin-stat-card ${accent ? "accent" : ""}`}>
      <Icon size={18} />
      <div>
        <div className="admin-stat-value">{value}</div>
        <div className="admin-stat-label">{label}</div>
      </div>
    </div>
  );
}
